export default {
	"indexTitle": {
		"title1": "สมัครสมาชิก",
		"title2": "เข้าสู่ระบบ",
		"title3": "ดาวน์โหลดแอปมือถือ",
		"title4": "ฝากเงิน",
		"title5": "ถอนเงิน",
		"title6": "กีฬา",
		"title7": "คาสิโนสด",
		"title8": "สล็อต",
		"title9": "เกมไพ่",
		"title10": "ยิงปลา",
		"title11": "แข่งสัตว์",
		"title12": "อีสปอร์ต",
		"title13": "ลอตเตอรี่",
		"title14": "โปรโมชั่น",
		"title15": "ดาวน์โหลดแอปมือถือ",

		"title16": "ประวัติการเข้าชม",
		"title17": "เริ่มเกม",
		"title18": "ข่าวล่าสุด",
		"title19": "โปรดทราบ เมื่อฝากเงินผ่านธนาคารประเภท Alipay, Octopus, tap&go, BOC เป็นต้น ต้องเลือก FPS และตรวจสอบชื่อภาษาอังกฤษเต็มของผู้รับให้ถูกต้อง!",
		"title20": "โปรโมชั่นทั้งหมด",
		"title21": "สมัครโปรโมชั่นนี้",
		"title22": "ฉันอยากเล่น",
		"title23": "ยอดคงเหลือ",
		"title24": "บัญชีของฉัน",
		"title25": "VIP",
		"title26": "ฝากเงิน",
		"title27": "ถอนเงิน",
		"title28": "เชิญเพื่อน",
		"title29": "บันทึกภารกิจ",
		"title30": "ศูนย์โปรโมชั่น",
		"title31": "ประวัติเกม",
		"title32": "ประวัติการเงิน",
		"title33": "ศูนย์ประกาศ",
		"title34": "โปรแกรมพันธมิตร",
		"title35": "สมาชิกโดยตรง",
		"title36": "คอมมิชชั่นของฉัน",
		"title37": "คำอธิบายกฎ",
		"title38": "จำนวนสมาชิกทีม",
		"title39": "สมาชิกทีมใหม่วันนี้",
		"title40": "จำนวนสมาชิกโดยตรง",
		"title41": "สมาชิกโดยตรงใหม่วันนี้",
		"title42": "ยอดเทิร์นทีมวันนี้",
		"title43": "ยอดเทิร์นโดยตรงวันนี้",
		"title44": "รายได้จากการแนะนำ",
		"title45": "โบนัส",
		"title46": "จำนวนสมาชิกลูกข่าย",
		"title47": "คาดการณ์โบนัสสูงที่เป็นไปได้",
		"title48": "ข้อมูลส่วนตัว",
		"title49": "รหัสแนะนำ",
		"title50": "ลิงก์เชิญ",
		"title51": "QR Code เชิญ",
		"title52": "เครื่องมือโปรโมท",
		"title53": "ดาวน์โหลด",
		"title54": "บัญชีของฉัน",
		"title55": "รหัสผ่านใหม่",
		"title56": "เปลี่ยนรหัสผ่านถอนเงิน",
		"title57": "รหัสผ่านเดิม",
		"title58": "จำเป็น",
		"title59": "กรุณากรอกรหัสผ่านเข้าสู่ระบบ",
		"title60": "ยืนยันรหัสผ่านใหม่",
		"title61": "ยกเลิก",
		"title62": "อัปเดต",
		"title63": "กรุณากรอกรหัสผ่านเดิม",
		"title64": "กรุณากรอกรหัสผ่านใหม่",
		"title65": "รหัสผ่านไม่ตรงกัน",
		"title66": "อัปเดตล้มเหลว",
		"title67": "รหัสผ่านเข้าสู่ระบบ",
		"title68": "รหัสผ่านถอนเงินใหม่",
		"title69": "6~10 ตัวอักษรภาษาอังกฤษและตัวเลขผสมกัน (อนุญาตอักขระพิเศษ)",
		"title70": "ยืนยันรหัสผ่านถอนเงิน",
		"title71": "กรุณากรอกรหัสผ่านเข้าสู่ระบบ",
		"title72": "กรุณากรอกรหัสผ่านถอนเงินใหม่",
		"title73": "ตัวเลือกการฝากเงิน",
		"title74": "โปรโมชั่น",
		"title75": "ไม่มีข้อมูล",
		"title76": "FPS",
		"title77": "เติมเงินร้านสะดวกซื้อ",
		"title78": "ไม่มีวงเงินฝาก",
		"title79": "ค่าธรรมเนียม",
		"title80": "ไม่มีค่าธรรมเนียม",
		"title81": "กรุณากรอกจำนวนเงินฝาก",
		"title82": "กรุณากรอกชื่อผู้ชำระเงิน",
		"title83": "โบนัสฝากเงิน",
		"title84": "กรุณาเลือก",
		"title85": "รับข้อมูลการชำระเงิน",
		"title86": "คำแนะนำการชำระเงิน",
		"title87": "1. กรุณาเลือกช่องทางชำระเงิน กรอกจำนวนเงิน แล้วกดส่ง",
		"title88": "2. หลังจากไปยังหน้าชำระเงินของบุคคลที่สาม ให้ทำตามคำแนะนำเพื่อฝากเงินให้เสร็จภายในเวลาที่กำหนด",
		"title89": "3. หลังชำระเงินเสร็จแล้ว รอให้หน้าจอแสดงข้อความชำระเงินสำเร็จก่อนปิดหน้า เพื่อหลีกเลี่ยงการพลาดรายการ",
		"title90": "4. หลังจากแพลตฟอร์มบุคคลที่สามยืนยันแล้ว ระบบจะโอนเข้าบัญชีของคุณโดยอัตโนมัติ",
		"title91": "5. ชำระเงินแล้วยังไม่เข้า? ชำระเงินไม่ได้? กรุณาติดต่อ [ฝ่ายบริการลูกค้าออนไลน์] เพื่อขอความช่วยเหลือ",
		"title92": "จำนวนเงินฝาก",
		"title93": "โปรดจดข้อมูลผู้รับด้านล่างแล้วทำการโอนเงิน",
		"title94": "เลขบัญชีผู้รับ",
		"title95": "ชื่อบัญชีผู้รับ",
		"title96": "QR Code ผู้รับ",
		"title97": "ที่อยู่ฝากเงิน",
		"title98": "กลับไปกรอกใหม่",
		"title99": "ยืนยันการฝากเงิน",
		"title100": "คัดลอกสำเร็จ!",
		"title101": "เริ่ม",
		"title102": "สิ้นสุด",
		"title103": "สามารถดูข้อมูลย้อนหลังได้สูงสุด 31 วันก่อนวันนี้",
		"title104": "ค้นหา",
		"title105": "ยอดฝากรวม",
		"title106": "ยอดถอนรวม",
		"title107": "ยอดโปรโมชั่นรวม",
		"title108": "บันทึกคืนยอด",
		"title109": "บันทึกปรับยอดด้วยมือ",
		"title110": "บันทึกการแนะนำ",
		"title111": "บันทึกรางวัลภารกิจ",
		"title112": "*อาจมีความล่าช้าในการเข้าถึงข้อมูล หากไม่พบประวัติเกม กรุณาลองใหม่ภายหลัง ข้อมูลภาพรวมรวมตามเวลา GMT+8 และแสดงเฉพาะ 10 วันล่าสุด",
		"title113": "ประเภทผลิตภัณฑ์",
		"title114": "เกม",
		"title115": "วันที่",
		"title116": "ยอดเดิมพันรวม",
		"title117": "ยอดเดิมพันที่ถูกต้องรวม",
		"title118": "ยอดชนะ/แพ้รวม",
		"title119": "ตัดสินแล้ว",
		"title120": "จำนวนเงินเดิมพัน",
		"title121": "รหัสธุรกรรม",
		"title122": "ไม่พบบันทึก",
		"title123": "ข้อมูลส่วนตัว",
		"title124": "ข้อมูลบัตรธนาคาร",
		"title125": "กระเป๋าเงินทั้งหมด",
		"title126": "เปลี่ยนรหัสผ่านเข้าสู่ระบบ/ถอนเงิน",
		"title127": "รหัสแนะนำ",
		"title128": "บัญชีผู้เล่น",
		"title129": "ชื่อจริง",
		"title130": "เบอร์โทรศัพท์",
		"title131": "เวลาสมัคร",
		"title132": "ยอดรวม",
		"title133": "เพิ่มบัตรธนาคารใหม่",
		"title134": "หมายเลขบัตรธนาคาร",
		"title135": "ชื่อเจ้าของบัญชี",
		"title136": "ต้องตรงกับชื่อบัญชีธนาคารของคุณ มิฉะนั้นจะไม่สามารถถอนเงินได้",
		"title137": "ธนาคารผู้รับ",
		"title138": "เลขบัญชีธนาคาร",
		"title139": "กรุณากรอกเลขบัญชีธนาคารของคุณ",
		"title140": "สาขาธนาคาร",
		"title141": "กรุณากรอกสาขาธนาคารของคุณ",
		"title142": "ยืนยัน",
		"title143": "กรุณากรอกชื่อเจ้าของบัญชี",
		"title144": "กรุณากรอกธนาคารผู้รับ",
		"title145": "กรุณากรอกเลขบัญชีธนาคาร",
		"title146": "กรุณากรอกสาขาธนาคาร",
		"title147": "เวลานับถอยหลัง",
		"title148": "ฝากเงินรายวัน",
		"title149": "HKD ขึ้นไป",
		"title150": "คะแนนกิจกรรม",
		"title151": "คะแนน",
		"title152": "เข้าสู่ระบบสะสม",
		"title153": "วัน",
		"title154": "เสร็จสิ้นแล้ว",
		"title155": "รับได้",
		"title156": "ภารกิจกำลังเตรียม",
		"title157": "ประกาศแพลตฟอร์ม",
		"title158": "รวม",
		"title159": "เวลาสมัคร",
		"title160": "เวลาตรวจสอบ",
		"title161": "รอการยืนยัน",
		"title162": "สำเร็จ",
		"title163": "ล้มเหลว",
		"title164": "จำนวนจริง",
		"title165": "หมายเหตุ",
		"title166": "หมายเลขคำสั่ง",
		"title167": "เนื้อหาเพิ่มเติม",
		"title168": "ระดับ VIP",
		"title169": "ระดับปัจจุบัน",
		"title170": "คำอธิบายสิทธิประโยชน์ VIP",
		"title171": "เลื่อนระดับ",
		"title172": "เงื่อนไข",
		"title173": "ผ่านแล้ว",
		"title174": "คะแนนปัจจุบัน",
		"title175": "ยินดีด้วยที่สำเร็จ",
		"title176": "สิทธิพิเศษเฉพาะ",
		"title177": "ระดับไม่เพียงพอ",
		"title178": "โบนัสวันเกิด",
		"title179": "รับ",
		"title180": "ประวัติคะแนน",
		"title181": "เลื่อน/ลดระดับ",
		"title182": "บันทึกการรับ",
		"title183": "จำนวนเงินถอน",
		"title184": "ยอดหักตรวจสอบรวม",
		"title185": "รหัสผ่านถอนเงิน",
		"title186": "ถอนจริง",
		"title187": "จำนวนเงินถอนควรอยู่ระหว่าง 1.00 ถึง 10.00",
		"title188": "กรุณาผูกบัตรธนาคารก่อน",
		"title189": "กรุณากรอกจำนวนเงินถอน",
		"title190": "กรุณากรอกรหัสผ่านถอนเงิน",
		"title191": "เข้าสู่ระบบผู้เล่น",
		"title192": "บัญชี",
		"title193": "รหัสผ่าน",
		"title194": "ยังไม่ได้สมัคร? คลิกที่นี่",
		"title195": "ลืมบัญชี",
		"title196": "ลืมรหัสผ่าน",
		"title197": "กรุณากรอกบัญชีผู้เล่น",
		"title198": "กรุณากรอกรหัสผ่านผู้เล่น",
		"title199": "บัญชีผู้เล่นต้องมี 6-12 ตัวอักษร",
		"title200": "China (จีน)",
		"title201": "Hong Kong (ฮ่องกง)",
		"title202": "กรอกใหม่",
		"title203": "สมัครเลย",
		"title204": "กรุณากรอกบัญชี",
		"title205": "กรุณากรอกรหัสผ่าน",
		"title206": "กรุณากรอกเบอร์โทรศัพท์",
		"title207": "ภารกิจรายวัน",
		"title208": "รูเล็ต",
		"title209": "ความคืบหน้าการแนะนำ",
		"title210": "ติดต่อเรา",
		"title211": "เกี่ยวกับเรา",
		"title212": "ออกจากระบบ",
		"title213": "สมัครฟรี",
		"title214": "กิจกรรมกีฬา",
		"title215": "บันเทิงสด",
		"title216": "เกมอิเล็กทรอนิกส์",
		"title217": "เกมไพ่",
		"title218": "เกมยิงปลา",
		"title219": "แข่งสัตว์",
		"title220": "อีสปอร์ต",
		"title221": "สแกน Android",
		"title222": "สแกน iOS",
		"title223": "เล่นเลย",
		"title224": "ระยะเวลากิจกรรม:",


		"title225": "รหัสผ่านถอนเงิน",
		"title226": "ช่องทางชำระเงิน",
		"title227": "ทั้งหมด",
		"title228": "ฝากเงินผู้เล่น",
		"title229": "ประวัติฝากเงิน",
		"title230": "ศูนย์ช่วยเหลือ",
		"title231": "ช่วยเหลือการฝากเงิน",
		"title232": "สวัสดี,",
		"title233": "จัดการบัตร",
		"title234": "ภารกิจรายวัน",
		"title235": "ภารกิจสะสม",
		"title236": "ภารกิจตามช่วงเวลา",
		"title237": "ภารกิจเช็คอิน",
		"title238": "ยังไม่เปิดใช้งาน",
		"title239": "เปลี่ยนรหัสผ่านถอนเงิน",
		"title240": "บัญชีผู้เล่น",
		"title241": "คะแนนรูเล็ต",
		"title242": "ชื่อจริง",
		"title243": "เบอร์โทรศัพท์",
		"title244": "วันเกิด",
		"title245": "เวลาสมัคร",
		"title246": "รหัสผ่านเข้าสู่ระบบล่าสุด",
		"title247": "บันทึก VIP",
		"title248": "ประวัติถอนเงิน",
		"title249": "จำนวนที่ถอนได้",
		"title250": "ตรวจสอบโปรโมชั่น",
		"title251": "ยอดหัก",
		"title252": "ค่าธรรมเนียมบริหาร",
		"title253": "ค่าธรรมเนียม",
		"title254": "ส่วนลด",
		"title255": "ตรวจสอบปกติ",
		"title256": "วันที่",
		"title257": "วัน",
		"title258": "จำนวนเงิน",
		"title259": "จำนวนที่ได้รับ:",
		"title260": "ยอดเทิร์น:",
		"title261": "เช็คอิน",
		"title262": "เช็คอินแล้ว",
		"title263": "วันเช็คอินรวม:",
		"title264": "รายได้เช็คอินรวม:",
		"title265": "ยอดฝากของวันนี้:",
		"title266": "ยอดเดิมพันที่ถูกต้องของวันนี้:",
		"title267": "จำนวนเงินฝากที่ต้องใช้:",
		"title268": "ยอดเทิร์นที่ถูกต้องที่ต้องใช้:",
		"title269": "จำนวนรอบหมุน:",
		"title270": "ครั้ง",
		"title271": "ทำภารกิจวันนี้เสร็จแล้ว",
		"title272": "ยังไม่ถึงเงื่อนไข",
		"title273": "หน้าแรก",
		"title274": "โปรโมชั่น",
		"title275": "หาเงิน",
		"title276": "บัญชี",
		"title277": "จำนวนวันที่ยังไม่เช็คอิน",

		"title278": "เงื่อนไขเช็คอิน",
		"title279": "สำเร็จแล้ว!",
		"title280": "ต้องยืนยันตัวตนระดับทอง",
		"title281": "จึงจะเข้าร่วมกิจกรรมนี้ได้",
		"title282": "เช็คอินรับโบนัส",
		"title283": "จำนวนวันกิจกรรมทั้งหมด",
		"title284": "โบนัสรวม",
		"title285": "เลือกสกุลเงิน",
		"title286": "กรุณากรอกชื่อภาษาอังกฤษ",
		"title287": "บัญชีอย่างน้อย 6 ตัวอักษร",
		"title288": "บัญชีธนาคาร",
		"title289": "ต่ำสุด:",
		"title290": "สูงสุด:",
		"title291": "จำนวนเงินเติม",
		"title292": "จำนวนเงินฝากขั้นต่ำ",
		"title293": "จำนวนเงินฝากสูงสุด",
		"title294": "สถานะเข้าสู่ระบบหมดอายุ กรุณาเข้าสู่ระบบใหม่",
		"title295": "ชื่อบัตร",
		"title296": "ธนาคาร",
		"title297": "เลขบัญชีบัตร",
		"title298": "กรุณากรอกรหัสผ่านถอนเงิน 6 หลัก",
		"title299": "การดำเนินการนี้จะโอนยอดคงเหลือทั้งหมดกลับไปยังกระเป๋าหลัก คุณต้องการดำเนินการต่อหรือไม่?",
		"title300": "ยกเลิก",
		"title301": "ดำเนินการต่อ",
		"title302": "รหัสผ่านถอนเงินเป็นตัวเลข 6 หลัก",
		"title303": "กู้คืนเงินทุน",
		"title304": "ฝ่ายบริการลูกค้า",
		"title305": "ยอดเทิร์นคงเหลือ",
		"title306": "คืนยอดแบบเรียลไทม์",
		"title307": "รับ",
		"title308": "จำนวนเงินฝากขั้นต่ำ",

		"title309": "ดาวน์โหลดสำหรับ iPhone",
		"title310": "รองรับ Apple",
		"title311": "ขึ้นไป",
		"title312": "ดาวน์โหลด Android",
		"title313": "รองรับ Android",
		"title314": "ผู้เล่น WeChat กรุณาใช้เบราว์เซอร์มือถือ",
		"title315": "คลิกเพื่อคัดลอก URL",

		"title316": "รางวัลกิจกรรม",
		"title317": "รางวัลของฉัน",
		"title318": "วงล้อ",
		"title319": "โบนัสของขวัญ:",
		"title320": "จำนวนเดิมพันที่ถูกต้องที่ต้องใช้สำหรับคาสิโนสด:",
		"title321": "จำนวนเดิมพันที่ถูกต้องที่ต้องใช้สำหรับยิงปลา:",
		"title322": "จำนวนเดิมพันที่ถูกต้องที่ต้องใช้สำหรับสล็อต:",
		"title323": "จำนวนเดิมพันที่ถูกต้องที่ต้องใช้สำหรับลอตเตอรี่:",
		"title324": "จำนวนเดิมพันที่ถูกต้องที่ต้องใช้สำหรับกีฬา:",
		"title325": "จำนวนเดิมพันที่ถูกต้องที่ต้องใช้สำหรับเกมไพ่:",
		"title326": "จำนวนเดิมพันที่ถูกต้องที่ต้องใช้สำหรับอื่น ๆ:",
		"title327": "บาคาร่า",

		"title328": "คืนยอดแบบเรียลไทม์",
		"title329": "คลิกเพื่อรับ",
		"title330": "บาท",
		"title331": "จำนวนคืนยอดคาสิโนสด:",
		"title332": "คืนยอดกีฬา:",
		"title333": "จำนวนคืนยอดสล็อต:",
		"title334": "จำนวนคืนยอดเกมไพ่:",
		"title335": "คำแนะนำการรับ",
		"title336": "เวลารับคือ 16:00:00-23:59:59 หากไม่รับภายในช่วงเวลานี้จะถูกรีเซ็ตเป็นศูนย์",
		"title337": "ให้บริการสอบถามข้อมูลธุรกรรมย้อนหลัง 14 วันเท่านั้น",
		"title338": "จำนวนคืนยอดยิงปลา:",
		"title339": "คืนยอดอีสปอร์ต:",
		"title340": "จำนวนคืนยอดแข่งสัตว์:",
		"title341": "กระเป๋าหลัก",
		"title342": "กระเป๋าเกม",
		"title343": "เลือกเส้นทาง",
		"title344": "ฝ่ายบริการลูกค้า (สาย 1)",
		"title345": "ฝ่ายบริการลูกค้า (สาย 2)",
		"title346": "ยอดเดิมพันที่ถูกต้อง",
		"title347": "ไม่เข้าร่วมกิจกรรม",
		"title348": "กิจกรรมเช็คอิน",
		"title349": "จับฉลากรูเล็ต",
		"title350": "กิจกรรมซองแดง",
		"title351": "เมนู",
		"title352": "กลับ",
		"title353": "ภาษา",
		"title354": "เงินเฟียต",
		"title355": "คริปโตเคอร์เรนซี",
		"title356": "สกุลเงินฝาก",
		"title357": "ประเภทการฝาก",
		"title358": "โอนธนาคาร",
		"title359": "FPS",
		"title360": "ยอดนิยม",
		"title361": "เลือกโปรโมชั่น",
		"title362": "ไม่มีโปรโมชั่น",
		"title363": "เลือกเครือข่าย",
		"title364": "สมาชิกที่ฝากครั้งแรกสามารถรับโบนัสฝากครั้งแรกได้ที่ส่วนโบนัส",
		"title365": "ที่อยู่ฝากเงิน",
		"title366": "คัดลอกที่อยู่",
		"title367": "เข้าอัตโนมัติ อัตราแลกเปลี่ยน",
		"title368": "สถาบันผู้รับ",
		"title369": "หมายเลขคำสั่ง",
		"title370": "ข้อมูลติดต่อ",
		"title371": "ยืนยันเบอร์โทร",
		"title372": "ยืนยันแล้ว",
		"title373": "ยืนยัน",
		"title374": "เปลี่ยนรหัสผ่านเข้าสู่ระบบ",
		"title375": "เปลี่ยนรหัสผ่านเป็นประจำเพื่อรักษาความเฉพาะและความปลอดภัย",
		"title376": "เปลี่ยนรหัสผ่านชำระเงิน",
		"title377": "กรุณากรอกรหัสผ่านเดิม",
		"title378": "ตัวเลข 6 หลัก (ไม่อนุญาตอักขระอื่น)",
		"title379": "ยืนยันเบอร์โทร",
		"title380": "แสดงทั้งหมด",
		"title381": "ย่อ",
		"title382": "โบนัสทั่วไป",
		"title383": "คะแนนรูเล็ต",
		"title384": "โบนัสที่รับรวมทั้งหมด",
		"title385": "ข้อมูลรายละเอียด",
		"title386": "รับได้ตอนนี้",
		"title387": "รับรางวัล",
		"title388": "โบนัสซองแดง",
		"title389": "สูงสุด",
		"title390": "โบนัสเช็คอิน",
		"title391": "โบนัสคาสิโนสดรายวัน",
		"title392": "โบนัสกีฬารายวัน",
		"title393": "โบนัสสล็อตรายวัน",
		"title394": "โบนัสเกมไพ่รายวัน",
		"title395": "โบนัสเกมยิงปลารายวัน",
		"title396": "โบนัสอีสปอร์ตรายวัน",
		"title397": "โบนัสเกมอื่น ๆ รายวัน",
		"title398": "คะแนนรูเล็ตรายวัน",
		"title399": "ฝากวันนี้",
		"title400": "ยอดเทิร์นวันนี้",
		"title401": "ซองแดงสุ่ม",
		"title402": "กฎและเงื่อนไขโปรโมชั่น",
		"title403": "สมัครซองแดง: ฝากเงิน ",
		"title404": "ยอดเทิร์น",
		"title405": "คุณสามารถรับได้ที่หน้ากิจกรรมวันนี้",
		"title406": "โบนัสจากโปรโมชั่นนี้ถอนได้ที่เทิร์น 1 เท่าเท่านั้น",
		"title407": "ผู้เล่นแต่ละคนสมัครได้วันละครั้ง ยอดซองแดงสุ่มสูงสุด",
		"title408": "ผู้เล่นแต่ละคนลงทะเบียนได้เพียงหนึ่งบัญชี การใช้หลายบัญชีเพื่อร่วมกิจกรรมถือเป็นการเก็งกำไรและจะถูกระงับ",
		"title409": "WG CLUB ขอสงวนสิทธิ์ในการแก้ไขหรือยกเลิกกิจกรรมนี้ และมีสิทธิ์ตีความขั้นสุดท้าย",
		"title410": "แพลตฟอร์มนี้เปิดระบบโบนัสเช็คอินรายวันพิเศษ เมื่อคุณทำตามเงื่อนไขที่กำหนดแล้ว จะมีสิทธิ์เช็คอิน การเช็คอินสะสมมอบเซอร์ไพรส์มากขึ้น และจำนวนวันเช็คอินจะรีเซ็ตทุกวันจันทร์เวลา 00:00!",
		"title411": "เข้าร่วมและทำตามเงื่อนไขเพื่อรับคะแนนรูเล็ตพิเศษทุกวัน ความสนุกไม่รู้จบ!",
		"title412": "เข้าร่วมและทำตามเงื่อนไขเพื่อรับรางวัลเงินสดพิเศษทุกวัน ความสนุกไม่รู้จบ!",
		"title413": "เข้าร่วมและทำตามเงื่อนไขเพื่อรับโบนัสกีฬาพิเศษทุกวัน ความสนุกไม่รู้จบ!",
		"title414": "เข้าร่วมและทำตามเงื่อนไขเพื่อรับโบนัสเกมอิเล็กทรอนิกส์พิเศษทุกวัน ความสนุกไม่รู้จบ!",
		"title415": "เข้าร่วมและทำตามเงื่อนไขเพื่อรับโบนัสเกมไพ่พิเศษทุกวัน ความสนุกไม่รู้จบ!",
		"title416": "เข้าร่วมและทำตามเงื่อนไขเพื่อรับโบนัสเกมยิงปลาพิเศษทุกวัน ความสนุกไม่รู้จบ!",
		"title417": "เข้าร่วมและทำตามเงื่อนไขเพื่อรับโบนัสอีสปอร์ตพิเศษทุกวัน ความสนุกไม่รู้จบ!",
		"title418": "เช็คอินติดต่อกัน",
		"title419": "คาสิโน",
		"title420": "โรงภาพยนตร์",
		"title421": "เล่นเลย",
		"title422": "วันนี้",
		"title423": "เมื่อวาน",
		"title424": "7 วันล่าสุด",
		"title425": "30 วันล่าสุด",
		"title426": "แสดง 100 รายการต่อหน้า จำนวนรวม:",
		"title427": "ประเภท",
		"title428": "เวลา",
		"title429": "ยังไม่ตัดสิน",
		"title430": "ยกเลิกแล้ว",
		"title431": "ที่เลือก",
		"title432": "สถานะ",
		"title433": "มีบัญชีอยู่แล้ว",
		"title434": "เกี่ยวกับส่วนลด",
		"title435": "จดจำชื่อผู้ใช้และรหัสผ่าน",
		"title436": "ยอดส่วนลดที่รับในช่วง 30 วันล่าสุด",
		"title437": "คอมมิชชั่นเอเจนต์",
		"title438": "รหัสแนะนำ",
		"title439": "โบนัสคอมมิชชั่น",
		"title440": "บันทึกการแลกรับ",
		"title441": "ยอดเดิมพันที่ถูกต้องของเพื่อนเมื่อวาน",
		"title442": "คอมมิชชั่นที่ถอนได้",
		"title443": "ข้อกำหนดการฝากและถอนมีอะไรบ้าง?",
		"title444": "ฝากขั้นต่ำ 100 HKD และถอนขั้นต่ำ 100 HKD สำหรับเอเจนต์ที่ถอนผ่าน USDT จำนวนต้องถึงกว่า 10,000 HKD กรุณาติดต่อฝ่ายบริการลูกค้าเพื่อผูก USDT สำหรับถอน คอมมิชชั่นต้องทำเทิร์นเดิมพันที่ถูกต้อง 1 เท่าก่อนถอน",
		"title445": "โบนัสแนะนำคำนวณอย่างไร?",
		"title446": "กฎคำนวณโบนัสแนะนำ: เชิญลูกข่ายสมัครและเดิมพัน คุณจะได้รับคืนยอด 0.3% จากยอดเดิมพันของสมาชิกลูกข่าย ตัวอย่าง: หากสมาชิกลูกข่ายเดิมพัน 5,000,000 HKD คอมมิชชั่นที่คุณได้รับคือ 5,000,000 * 0.3% = 15,000 HKD",
		"title447": "โบนัสเงินปันผลจะตัดสินผลทุกกี่ครั้ง?",
		"title448": "คอมมิชชั่นเอเจนต์ตัดสินผลแบบเรียลไทม์ คุณจะได้รับคอมมิชชั่นทันทีเมื่อสมาชิกลูกข่ายเดิมพัน",
		"title449": "รางวัลแข่งสัตว์อีสปอร์ตรายวัน",
		"title450": "เข้าร่วมและทำตามเงื่อนไขเพื่อรับโบนัสแข่งสัตว์อีสปอร์ตพิเศษทุกวัน ความสนุกไม่รู้จบ!",
		"title451": "เลื่อนเป็น",
		"title452": "กฎ",
		"title453": "ระดับ",
		"title454": "โบนัสเลื่อนระดับ",
		"title455": "โบนัสรายสัปดาห์",
		"title456": "โบนัสรายเดือน",
		"title457": "โบนัสโอน",
		"title458": "ระบบระดับ VIP",
		"title459": "XP คงระดับ",
		"title460": "XP เลื่อนระดับ",
		"title461": "เกณฑ์การเลื่อนระดับ",
		"title462": "เมื่อสมาชิกมียอดเดิมพันที่ถูกต้องครบตามระดับที่กำหนด ระบบจะตัดสินและเลื่อนระดับ VIP โดยอัตโนมัติ (ยอดเดิมพันที่ถูกต้องที่ต้องใช้ในการเลื่อนแต่ละระดับ VIP จะคำนวณใหม่)",
		"title463": "ข้อกำหนดคงระดับ",
		"title464": "หลังจากสมาชิกถึงระดับ VIP แล้ว ต้องทำยอดเทิร์นคงระดับให้ครบภายใน 60 วัน (ครึ่งหนึ่งของยอดเทิร์นที่ต้องใช้เลื่อนมาระดับปัจจุบันเท่ากับยอดเทิร์นคงระดับ) หากมีการเลื่อนระดับในช่วงนี้ ข้อกำหนดคงระดับจะคำนวณใหม่ตามระดับปัจจุบัน",
		"title465": "เกณฑ์การลดระดับ",
		"title466": "หากสมาชิกไม่ทำตามข้อกำหนดคงระดับภายใน 60 วัน ระบบจะลดลงหนึ่งระดับโดยอัตโนมัติ (ยอดเดิมพันที่ถูกต้องของแต่ละระดับ VIP จะคำนวณใหม่เมื่อลดระดับ) และสิทธิประโยชน์จะปรับตามระดับที่ลดลง",
		"title467": "โบนัสเลื่อนระดับ",
		"title468": "หลังจากสมาชิกเลื่อนระดับสูงขึ้น สามารถรับโบนัสเลื่อนระดับได้ที่หน้า VIP โบนัสเลื่อนระดับแต่ละระดับรับได้เพียงครั้งเดียว โบนัสเลื่อนระดับต้องทำเทิร์น 1 เท่าก่อนถอน",
		"title469": "โบนัส VIP รายสัปดาห์",
		"title470": "โบนัส VIP รับได้สัปดาห์ละครั้ง จำนวนโบนัสตรงตามระดับปัจจุบัน อัปเดตทุกวันจันทร์เวลา 00:00 หากเกินกำหนดจะไม่สามารถรับโบนัสสัปดาห์ก่อนได้ โบนัสต้องทำเทิร์นเดิมพันที่ถูกต้อง 1 เท่าก่อนถอน และเข้าร่วมได้สัปดาห์ละครั้ง",
		"title471": "โบนัส VIP รายเดือน",
		"title472": "โบนัส VIP รับได้เดือนละครั้ง จำนวนโบนัสตรงตามระดับปัจจุบัน อัปเดตวันที่ 1 ของทุกเดือนเวลา 00:00 หากเกินกำหนดจะไม่สามารถรับโบนัสเดือนก่อนได้ โบนัสต้องทำเทิร์นเดิมพันที่ถูกต้อง 1 เท่าก่อนถอน และเข้าร่วมได้เดือนละครั้ง",
		"title473": "VIP Club",
		"title474": "คัดลอก",
		"title475": "เชิญเพื่อน",
		"title476": "สอบถามผลงาน",
		"title477": "รับรางวัลแล้ว",
		"title478": "รับแล้วสัปดาห์นี้",
		"title479": "รับแล้วเดือนนี้",
		"title480": "รับแล้ววันนี้",
		"title481": "บัญชี (ตัวอักษรภาษาอังกฤษและตัวเลข 6-12 ตัว)",
		"title482": "รหัสผ่าน (6~16 ตัวอักษร)",
		"title520": "รายละเอียดกิจกรรม",
		"title521": "รับ",
		"title522": "โบนัสเช็คอินรายวัน: ทำตามเงื่อนไขที่กำหนดเพื่อรับโบนัสเช็คอิน",
		"title523": "สตรีคเช็คอินรีเซ็ตทุกวันจันทร์เวลา 00:00",
		"title524": "จะได้รับรอบหมุนรูเล็ตได้อย่างไร?",
		"title525": "1. รอบหมุนรูเล็ตแจกอัตโนมัติตามยอดฝากรายวัน",
		"title526": "2. รายละเอียดคะแนนรูเล็ต กรุณาดูที่ศูนย์โปรโมชั่น",
		"title527": "⚠️ หมายเหตุ:",
		"title528": "1. คะแนนรูเล็ตต้องใช้ในวันเดียวกัน",
		"title529": "2. คะแนนรูเล็ตที่ไม่ได้ใช้จะไม่ยกไปวันถัดไป และรีเซ็ตทุกวันเวลา 00:00",
		"title530": "3. รางวัลรูเล็ตต้องทำเทิร์นเดิมพันที่ถูกต้อง 1 เท่าก่อนถอน",
		"title531": "คลังโบนัส",
		"title532": "Yu'e Bao",
		"title533": "รับโบนัสได้ทุกเมื่อ",
		"title534": "สร้างรายได้จากยอดคงเหลือที่ว่าง",
		"title535": "ยอดรวม (HK$)",
		"title536": "อัตราดอกเบี้ยรายปี",
		"title537": "โอนเข้า",
		"title538": "รับ",
		"title539": "โอนออก",
		"title540": "รายได้ปัจจุบัน",
		"title541": "โบนัสรวม",
		"title542": "รายได้สะสม",
		"title543": "รายละเอียด",
		"title544": "กฎ Yu'e Bao",
		"title545": "รายได้",
		"title546": "การรับ",
		"title547": "การโอนออก",
		"title548": "การโอนเข้า",
		"title549": "รายได้",
		"title550": "ยังไม่มีบันทึก",
		"title551": "ยอดกระเป๋าหลัก",
		"title552": "ยอด Yu'e Bao",
		"title553": "กรอกจำนวนเงิน",
		"title554": "ยืนยัน",
		"title555": "กฎดอกเบี้ย\n• เงินในบัญชีหลักต้องทำเทิร์นถอนครบก่อนโอนเข้า Yu'e Bao\n• ดอกเบี้ยคิดตามอัตรายปี โดยแต่ละชั่วโมงเป็นหนึ่งรอบตัดสินผล:\nยอด Yu'e Bao × อัตรายปี ÷ 365 ÷ 24 = รายได้ต่อชั่วโมง\n• รายได้เริ่มหลังฝาก 2 ชั่วโมง โบนัสโอนออกไม่ได้รับผลกระทบ\n• แต่ละครั้งฝากคิดดอกเบี้ยสูงสุด 12 ชั่วโมง หลัง 12 ชั่วโมงต้องฝากใหม่เพื่อรับดอกเบี้ยต่อ\n• ตัวอย่างอัตรายปี 365%: 100,000 HKD ใน Yu'e Bao ได้ดอกเบี้ยประมาณ 500 HKD ใน 12 ชั่วโมง\n\nกฎการโอนออก\nอัตราโบนัส:\n• แต่ละครั้งโอนจาก Yu'e Bao ไปบัญชีหลักได้โบนัส 1% สูงสุด 2 ครั้ง/วัน สูงสุด 388 HKD ต่อโบนัส 1%\nข้อกำหนดการโอน:\n• หลังโอนไปบัญชีหลัก ต้องทำเทิร์น 1 เท่าของ (จำนวนโอน + โบนัส) ก่อนถอน",
		"title556": "ดำเนินการล้มเหลว กรุณาลองใหม่ภายหลัง",
		"title557": "กระเป๋าหลัก (HK$)",
		"title558": "กระเป๋า Yu'e Bao (HK$)",
		"title559": "จำนวนโอนเข้า",
		"title560": "รหัสผ่านถอนเงิน",
		"title561": "เงินในบัญชีหลักต้องทำเทิร์นและเงื่อนไขถอนครบก่อนโอนเข้า Yu'e Bao",
		"title562": "โอนออก",
		"title563": "ยอดคงเหลือทั้งหมด",
		"title564": "รายได้ที่ยังไม่รับ",
		"title565": "จำนวนโอนออก",
		"title566": "จำนวนโบนัส",
		"title567": "กฎโบนัส:",
		"title568": "1. โบนัสโอนออก {rate}% 2 ครั้ง/วัน",
		"title569": "2. หลังโอน เงินต้น + โบนัสต้องทำเทิร์น 1 เท่า",
		"title572": "รับรวมทั้งหมด",
		"title573": "โบนัสโอนออก",
		"title574": "คลังโบนัส",
		"title575": "รับได้",
		"title576": "กำลังดำเนินการ",
		"title577": "รับแล้ว",
		"title578": "หมดอายุ",
		"title579": "ศูนย์คะแนน",
		"title580": "เทิร์นลำดับความสำคัญ",
		"title581": "รีเฟรช",
		"title582": "โบนัส",
		"title583": "ฝากครั้งแรกสูงสุด 150% - รับโดยการเทิร์น",
		"title584": "ยอดเทิร์นที่ต้องใช้",
		"title585": "เริ่มเทิร์น",
		"title586": "กำหนดสิ้นสุดเทิร์น",
		"title587": "เกมที่นับ",
		"title588": "เสร็จสิ้นแล้ว",
		"title589": "ยอดเทิร์นปัจจุบัน",
		"title590": "คงเหลือ",
		"title591": "รางวัลแบบขั้น",
		"title592": "โบนัสรวม",
		"title593": "รับแล้ว",
		"title594": "ขั้น ",
		"title594b": "",
		"title595": "ความคืบหน้า ≥",
		"title596": "มีสิทธิ์ — รับขั้นนี้ได้เลย",
		"title597": "รับรางวัล",
		"title598": "ยังไม่ถึงความคืบหน้าที่กำหนด",
		"title599": "ไม่มีสิทธิ์",
		"title600": "ไม่มีโปรโมชั่นที่กำลังดำเนินการ",
		"title601": "สด (20%), กีฬา (100%), ไพ่ (100%), สล็อต (100%), อีสปอร์ต (100%), ยิงปลา (100%)",
		"title602": "ไม่มีโบนัสที่รับได้",
		"title603": "ไม่มีบันทึกที่รับแล้ว",
		"title604": "ไม่มีบันทึกที่หมดอายุ",
		"title605": "ศูนย์คะแนนเปิดเร็ว ๆ นี้",
		"title606": "ตั้งลำดับความสำคัญเทิร์น",
		"title607": "ยอดรับสะสม",
		"title608": "ไม่มีเพิ่มเติม",
		"title609": "โบนัส VIP",
		"title610": "โปรโมชั่นด้วยมือ",
		"title611": "รางวัล",
		"title612": "เกมยอดนิยม",
		"title613": "มินิเกม",
		"title614": "ค้นหาเกม...",
		"title615": "ไม่พบเกม",
		"title616": "ไม่มีเกมยอดนิยม",
		"title617": "ไม่มีมินิเกม",
		"title618": "ไม่มีเกมสด",
		"title619": "ไม่มีเกม",
		"title620": "กลับไปยังค่ายเกม",
		"title621": "ผู้ชนะ",
		"title622": "กำลังโหลด",
		"title623": "ผู้ใช้",
		"title624": "คูณ",
		"title625": "ชนะ",
		"title626": "เปลี่ยนภาษา",
		"title627": "ใหม่",
		"title628": "ฮิต",
		"title629": "โปรโมชั่นพิเศษสำหรับคุณ",
		"title630": "ดูรายละเอียด",
		"title631": "ไม่มีโปรโมชั่น",
		"title632": "ยินดีต้อนรับกลับ",
		"title633": "เข้าสู่ระบบเพื่อเริ่มเล่น",
		"title634": "ยังไม่มีบัญชี?",
		"title635": "สร้างบัญชี",
		"title636": "สมัครเพื่อเริ่มเล่น",
		"title637": "ข้อมูลบัญชี",
		"title638": "ถัดไป",
		"title639": "ข้อมูลธนาคาร",
		"title640": "เลือกธนาคาร",
		"title641": "มีบัญชีอยู่แล้ว?",
		"title642": "อันดับ",
		"title643": "กรอกชื่อเต็ม",
		"title644": "ยืนยันรหัสผ่าน",
		"title645": "เข้าสู่ระบบล้มเหลว",
		"title646": "สมัครสมาชิกล้มเหลว",
		"title647": "ส่งรหัสยืนยันล้มเหลว",
		"title648": "รหัสผ่านอย่างน้อย 6 ตัวอักษร",
		"title649": "กรุณากรอกชื่อ",
		"title650": "เดิมพัน",
		"title651": "บัญชีธนาคาร / PromptPay",
		"title652": "ประวัติการเล่น",
		"title653": "ยังไม่มีประวัติการเล่น",
		"title654": "ช่องทางติดต่อ",
		"title655": "บริการ 24 ชม.",
		"title656": "ตอบกลับเร็ว",
		"title657": "แชทปลอดภัย",
		"title658": "เลือกช่องทางติดต่อ",
		"title659": "แชทเลย",
		"title660": "ยังไม่มีช่องทางติดต่อ",
		"title661": "LINE",
		"title662": "ระดับของคุณ",
		"title663": "ยอดฝากสะสม",
		"title664": "ถึงระดับสูงสุดแล้ว",
		"title665": "ทุกระดับ",
		"title666": "ปัจจุบัน",
		"title667": "ช่องทาง",
		"title668": "จำนวน",
		"title669": "ชำระเงิน",
		"title670": "ยอดคงเหลือ",
		"title671": "บัญชีของคุณ",
		"title672": "เลือกวิธีชำระเงิน",
		"title673": "ช่องทางที่เลือก",
		"title674": "เลือกจำนวนเงิน",
		"title675": "หรือระบุจำนวน",
		"title676": "ระบุจำนวนเงิน",
		"title677": "ฝากขั้นต่ำ",
		"title678": "บาท",
		"title679": "โอนธนาคาร + อัปโหลดสลิป",
		"title680": "ชำระออนไลน์",
		"title681": "บัญชีรับเงิน",
		"title682": "ธนาคาร",
		"title683": "วอลเล็ต",
		"title684": "ยังไม่เปิดถอนผ่านวอลเล็ต",
		"title685": "ถอนขั้นต่ำ ",
		"title686": "ถอนสูงสุด",
		"title687": "ถอน",
		"title688": "ยอดถอนขั้นต่ำ: ",
		"title689": "ที่อยู่ USDT",
		"title690": "กรอกที่อยู่ USDT",
		"title691": "ผูก USDT",
		"title692": "ผูกแล้ว",
		"title693": "กรุณาผูกที่อยู่ USDT ก่อน",
		"title694": "เครือข่าย",
		"title695": "คืนยอดเกมของคุณ",
		"title696": "คืนเงินขาดทุน",
		"title697": "ยอดขาดทุนเมื่อวาน",
		"title698": "อัตราเงินชดเชยขาดทุน",
		"title699": "ยอดที่รับได้",
		"title700": "กำลังโหลด...",
		"title701": "กำลังรับ...",
		"title702": "รับแล้ววันนี้",
		"title703": "ยังไม่มีเงินชดเชยขาดทุน",
		"title704": "รับ",
		"title705": "รับสำเร็จ",
		"title706": "คืนยอดขาดทุนจากการเดิมพันเมื่อวาน",
		"title707": "ขอคืนยอดขาดทุนเมื่อวาน",
		"title708": "ไม่มียอดขาดทุนที่เข้าเงื่อนไข (เมื่อวานคุณไม่ขาดทุน)",
		"title709": "วิธีขอชดเชยขาดทุน",
		"title710": "เล่นเกมและสะสมแต้มเดิมพัน",
		"title711": "วิธีคำนวณขาดทุน: ยอดเดิมพันรวม - ยอดชนะรวม - เงินคืนวันก่อน",
		"title712": "หากขาดทุน คุณสามารถรับเงินคืนได้ทุกวัน",
		"title713": "อัตราเงินคืนขึ้นอยู่กับระดับของคุณ",
		"title714": "ประวัติคืนเงินขาดทุน",
		"title715": "ยังไม่มีบันทึกการชดเชยขาดทุน",
		"title716": "คืนยอดเดิมพันเมื่อวาน",
		"title717": "ขอคืนยอดเดิมพันเมื่อวาน",
		"title718": "รับเงินคืนไม่มีขั้นต่ำการเดิมพัน",
		"title719": "วิธีรับเงินคืน",
		"title720": "เล่นเกมและสะสมแต้มเดิมพัน",
		"title721": "ยอดเงินคืนคิดจากยอดเดิมพันวันก่อน",
		"title722": "กลับมารับเงินคืนได้ทุกวัน!",
		"title723": "อัตราเงินคืนขึ้นอยู่กับระดับของคุณ",
		"title724": "ประวัติใบเสร็จเงินคืน",
		"title725": "เงินคืน",
		"title726": "ยังไม่มีบันทึกเงินคืน",
		"title727": "วงล้อนำโชค",
		"title728": "ตั๋วของคุณ",
		"title729": "ใช้ได้วันนี้",
		"title730": "วงล้อ",
		"title731": "ประวัติ",
		"title732": "หมุนวงล้อ",
		"title733": "ใบ",
		"title734": "ตั๋วไม่พอ",
		"title735": "หมุนครั้งละ 1 ใบ",
		"title736": "รางวัลทั้งหมด",
		"title737": "รางวัล",
		"title738": "เช็คอิน",
		"title739": "เช็คอินทั้งหมด",
		"title740": "คะแนนสะสม",
		"title741": "คะแนน",
		"title742": "ทำเงื่อนไขครบแล้วรับโบนัสเช็คอิน",
		"title743": "เช็คอินทันที",
		"title744": "เช็คอินแล้ว",
		"title745": "วันนี้",
		"title746": "กฎการเช็คอิน",
		"title747": "ต้องทำยอดฝากและยอดเดิมพันที่มีผลในวันนั้นให้ครบตามเงื่อนไขของวันนั้น จึงจะรับโบนัสเช็คอินได้",
		"title748": "หากขาดเช็คอิน วันสะสมจะเริ่มนับใหม่จากวันที่ 1 ยิ่งเช็คอินต่อเนื่องรางวัลยิ่งมากขึ้น",
		"title749": "สะสมคะแนนในร้านแลกของรางวัล",
		"title750": "ทำเงื่อนไขครบแล้วเช็คอินรับโบนัส <em>{n}</em>",
		"title751": "/",
		"title752": "",
		"title753": "อา,จ,อ,พ,พฤ,ศ,ส",
		"title570": "กรุณากรอกรหัสผ่านถอนเงิน 6 หลัก",
		"title571": "ไม่มียอดคงเหลือให้โอนออก",
		"title483": "กรุณากรอกชื่อจริงภาษาอังกฤษ",
		"title484": "กรุณากรอกเบอร์โทรศัพท์",
		"title485": "รหัสผ่านถอนเงิน (ตัวเลข 6 หลัก)",
		"title486": "กรุณากรอกรหัสผ่านถอนเงินเดิม",
		"title487": "รหัสยืนยัน",
		"title487Err": "กรุณากรอกรหัสยืนยัน",
		"title488": "รับรหัส",
		"title489": "เข้าสู่ระบบด้วยบัญชี",
		"title490": "เข้าสู่ระบบด้วยเบอร์โทร",
		"title491": "ลืมรหัสผ่าน",
		"title492": "ตั้งรหัสผ่านใหม่",
		"title493": "ยืนยัน",
		"title494": "รับโบนัสคอมมิชชั่นแล้ว",
		"title495": "ลบ",
		"title496": "ลบบัตรธนาคาร",
		"title497": "ยกเลิก",
		"title498": "ยืนยันการลบ",
	},

};
